import React, { useEffect } from "react";

import { ConfirmDocumentPage } from "pages/confirm-document-page/confirm-document-page";
import { ErrorPage } from "pages/error-page/error-page";
import { InfoPage } from "pages/info-page/info-page";
import { LoginPageExpiredPage } from "pages/login-page-expired-page/login-page-expired-page";
import { LoginPasswordPage } from "pages/login-password-page";
import { LoginUpdatePasswordPage } from "pages/login-update-password-page/login-update-password-page";
import { RegisterPhonePage } from "pages/register-phone-page/register-phone-page";
import { SmsCodePage } from "pages/sms-code-page/sms-code-page";

import packageJson from "../../../package.json";
import { Header } from "../header/header";
import { PageWrapper } from "../page-wrapper/page-wrapper";

import "./app.scss";

/** Текущая страница */
export enum CurrentPage {
  /** Форма ввода телефона */
  RegisterPhone = "register-phone",

  /** Страница ввода кода из смс */
  EnterSms = "enter-sms",

  /** Страница Восстановления пароля */
  ConfirmDocument = "confirm-document",

  /** Страница обновления пароля */
  LoginUpdatePassword = "login-update-password",

  /** Страница ввода пароля */
  LoginPassword = "login-password",

  /** Страница обновления пароля из авторизованной зоны */
  UserUpdatePassword = "user-update-password",

  /** Страница с ошибками */
  Error = "error",

  /** Страница пустышка. Мы переходим на нее при смене пароля из авторизованной зоны и сразу происходит редирект на новую страницу
   * Костыль, закрывающий проблему того, что кейклок не подтягивает тему на первой форме при переходе из авторизованной зоны
   */
  VoidAuth = "void-auth",

  /** Страница блокировки пользователя */
  UserBlocked = "user-blocked",

  /** Срок действия страницы истек */
  LoginPageExpired = "login-page-expired",

  /** Вы уже вошли */
  Info = "info",
}

declare global {
  interface Window {
    /** Текущая версия билда */
    buildNumber: string;
    /** Текущая страница. Указывает какая страница будет показываться. Переменная передается из шаблона keycloak */
    currentPage: CurrentPage;
    /** Путь по которому будет отправляться форма. Переменная передается из шаблона keycloak */
    loginAction: string | undefined;
    /** Ошибка отправки формы. Переменная передается из шаблона keycloak */
    error: string | undefined;
    /** Имя пользователя(Номер телефона). Переменная передается из шаблона keycloak */
    username: string | undefined;
    /** Ссылка "Забыли пароль?" */
    loginResetCredentialsUrl: string | undefined;
    /** Ошибки, записываемые в error.ftl */
    errorOnErrorPage: string | undefined;
    /** Директория хранения скриптов, стилей, прочих файлов кейклока */
    resourcesPath: string;
    /** Урл для рестарта флоу */
    loginRestartFlowUrl: string;
    /** Номер телефона на форме ввода кода из смс */
    phoneNumber: string;
  }
}

// window.currentPage = CurrentPage.LoginPassword;
// window.loginAction = "https://google.com";
// window.error = "phoneRegBlocked5";
// window.errorOnErrorPage = "docAuthTooManyAttempts";
// window.loginRestartFlowUrl = "https://google.com";

const App = () => {
  useEffect(() => {
    window.buildNumber = packageJson.version;
  }, []);

  const renderPageByPage = (currentPage: CurrentPage) => {
    switch (currentPage) {
      case CurrentPage.EnterSms:
        return <SmsCodePage />;
      case CurrentPage.ConfirmDocument:
        return <ConfirmDocumentPage />;
      case CurrentPage.LoginUpdatePassword:
      case CurrentPage.UserUpdatePassword:
        return <LoginUpdatePasswordPage />;
      case CurrentPage.LoginPassword:
        return <LoginPasswordPage />;
      case CurrentPage.Error:
        return <ErrorPage />;
      case CurrentPage.LoginPageExpired:
        return <LoginPageExpiredPage />;
      case CurrentPage.Info:
        return <InfoPage />;
      case CurrentPage.RegisterPhone:
      default:
        return <RegisterPhonePage />;
    }
  };

  return (
    <div className="app">
      <Header className={"app__header"} />
      <main className={"app__main"}>
        <PageWrapper>{renderPageByPage(window.currentPage)}</PageWrapper>
      </main>
    </div>
  );
};

export default App;
